module.exports = __webpack_public_path__ + "img/uavbg.60cefc24.png";